import React from "react";
import { useNavigate } from "react-router";
import {
  Pointsvg,
  Textsvg,
  Linesvg,
  Printsvg,
  Polygonsvg,
  Circlesvg,
  Rectanglesvg,
  Clearsvg,
} from "./icons";
import styles from "./assets/css/Draw.module.scss";
import path from "src/config/search.json";

interface IProps {
  drawClickHandler: (graphicType: string) => void;
  clearGraphicsHandler: () => void;
}

const SketchTools = ({ drawClickHandler, clearGraphicsHandler }: IProps) => {
  const navigate = useNavigate();
  const [tools, setTools] = React.useState([
    {
      id: "rectangle",
      active: false,
      label: "Rectangle",
      icon: <Rectanglesvg />,
    },
    { id: "circle", active: false, label: "Radius", icon: <Circlesvg /> },
    { id: "polygon", active: false, label: "Area", icon: <Polygonsvg /> },
    { id: "polyline", active: false, label: "Line", icon: <Linesvg /> },
    { id: "point", active: false, label: "Point", icon: <Pointsvg /> },
    { id: "text", active: false, label: "Text", icon: <Textsvg /> },
  ]);
  const keys = Object.keys(path.services);
  const currentkey = keys[3];

  const handleClick = () => {
    navigate(`../../${currentkey}/${path.services.General[1].url}`);
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <div className={styles["tools-container"]}>
        {tools.map((x) => (
          <div
            aria-label="Button"
            key={x.id}
            className={`${styles[`btn-class`]} ${
              x.active ? styles["btn-class-active"] : ""
            }`}
            onClick={() => {
              drawClickHandler(x.id);
              setTools((prev) => {
                const tmpTool = prev.map((y) => {
                  if (y.id == x.id) {
                    y.active = true;
                  } else {
                    y.active = false;
                  }
                  return y;
                });
                return tmpTool;
              });
            }}
          >
            {x.icon}
            <span className={styles["btn-label"]}>{x.label}</span>
          </div>
        ))}

        <div
          aria-label="Button"
          className={styles["btn-class"]}
          onClick={() => {
            setTools((prev) => {
              const tmpTools = prev.map((y) => {
                y.active = false;
                return y;
              });
              return tmpTools;
            });
            clearGraphicsHandler();
          }}
        >
          <Clearsvg />
          <span className={styles["btn-label"]}>Clear</span>
        </div>
        <div
          aria-label="Button"
          className={styles["btn-class"]}
          onClick={() => {
            handleClick();
          }}
        >
          <Printsvg />
          <span className={styles["btn-label"]}>Print</span>
        </div>
      </div>
    </div>
  );
};

export default SketchTools;
